import { IntlShape } from "react-intl";

export const TRANSIT_CLEARANCE_OPTIONS = (intl: IntlShape) => [
  {
    value: "no",
    label: intl.formatMessage({
      id: "new-request.service.noTransitClearance",
      defaultMessage: "No, do not include Transit clearance.",
    }),
  },
  {
    value: "yes_provider",
    label: intl.formatMessage({
      id: "new-request.service.yesTransitClearance",
      defaultMessage: "Yes, please provide Transit clearance.",
    }),
  },
  {
    value: "yes_internal",
    label: intl.formatMessage({
      id: "new-request.service.yesTransitClearanceInternally",
      defaultMessage: "Yes, but it will be arranged internally.",
    }),
  },
  {
    value: "yes_other",
    label: intl.formatMessage({
      id: "new-request.service.other",
      defaultMessage: "Other",
    }),
  },
];

export const IMPORT_CLEARANCE_OPTIONS = (intl: IntlShape) => [
  {
    value: "no",
    label: intl.formatMessage({
      id: "new-request.service.noImportClearance",
      defaultMessage: "No, do not include Import clearance.",
    }),
  },
  {
    value: "yes_provider",
    label: intl.formatMessage({
      id: "new-request.service.yesImportClearance",
      defaultMessage: "Yes, please provide Import clearance.",
    }),
  },
  {
    value: "yes_internal",
    label: intl.formatMessage({
      id: "new-request.service.yesImportClearanceInternally",
      defaultMessage: "Yes, but it will be arranged internally.",
    }),
  },
  {
    value: "yes_other",
    label: intl.formatMessage({
      id: "new-request.service.other",
      defaultMessage: "Other",
    }),
  },
];

export const EXPORT_CLEARANCE_OPTIONS = (intl: IntlShape) => [
  {
    value: "no",
    label: intl.formatMessage({
      id: "new-request.service.noExportClearance",
      defaultMessage: "No, do not include Export clearance.",
    }),
  },
  {
    value: "yes_provider",
    label: intl.formatMessage({
      id: "new-request.service.yesExportClearance",
      defaultMessage: "Yes, please provide Export clearance.",
    }),
  },
  {
    value: "yes_internal",
    label: intl.formatMessage({
      id: "new-request.service.yesExportClearanceInternally",
      defaultMessage: "Yes, but it will be arranged internally.",
    }),
  },
  {
    value: "yes_other",
    label: intl.formatMessage({
      id: "new-request.service.other",
      defaultMessage: "Other",
    }),
  },
];

export const INCOTERM_OPTIONS = (intl: IntlShape) => [
  {
    value: "None",
    label: intl.formatMessage({
      id: "settings.payment-locations.none",
      defaultMessage: "None",
    }),
  },
  {
    value: "EXW",
    label: intl.formatMessage({
      id: "settings.payment-locations.exWorks",
      defaultMessage: "EXW - Ex Works",
    }),
  },
  {
    value: "FCA",
    label: intl.formatMessage({
      id: "settings.payment-locations.freeCarrier",
      defaultMessage: "FCA - Free Carrier",
    }),
  },
  {
    value: "CPT",
    label: intl.formatMessage({
      id: "settings.payment-locations.carriagePaidTo",
      defaultMessage: "CPT - Carriage Paid To",
    }),
  },
  {
    value: "CIP",
    label: intl.formatMessage({
      id: "settings.payment-locations.carriageInsurancePaidTo",
      defaultMessage: "CIP - Carriage Insurance Paid To",
    }),
  },
  {
    value: "DAT",
    label: intl.formatMessage({
      id: "settings.payment-locations.deliveryAtTerminal",
      defaultMessage: "DAT - Delivery at Terminal",
    }),
  },
  {
    value: "DAP",
    label: intl.formatMessage({
      id: "settings.payment-locations.deliveryAtPlace",
      defaultMessage: "DAP - Delivery at Place",
    }),
  },
  {
    value: "DDP",
    label: intl.formatMessage({
      id: "settings.payment-locations.deliveryDutyPaid",
      defaultMessage: "DDP - Delivery Duty Paid",
    }),
  },
  {
    value: "FAS",
    label: intl.formatMessage({
      id: "settings.payment-locations.freeAlongsideShip",
      defaultMessage: "FAS - Free Alongside Ship",
    }),
  },
  {
    value: "FOB",
    label: intl.formatMessage({
      id: "settings.payment-locations.freeOnBoard",
      defaultMessage: "FOB - Free on Board",
    }),
  },
  {
    value: "CFR",
    label: intl.formatMessage({
      id: "settings.payment-locations.costAndFreight",
      defaultMessage: "CFR - Cost and Freight",
    }),
  },
  {
    value: "CIF",
    label: intl.formatMessage({
      id: "settings.payment-locations.costInsuranceFreight",
      defaultMessage: "CIF - Cost, Insurance and Freight",
    }),
  },
  {
    value: "DPU",
    label: intl.formatMessage({
      id: "settings.payment-locations.deliveredAtPlaceUnloaded",
      defaultMessage: "DPU - Delivered at Place Unloaded",
    }),
  },
];
